import React, {useLayoutEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import StyledDatabaseEntityContextWrapper
  from 'components/templates/Wrappers/Database/Entities/DatabaseEntityContextWrapper/DatabaseEntityContextWrapper.styles';
import DatabaseEntitySectionPanel
  from 'components/organisms/SectionPanels/DatabaseEntitySectionPanel/DatabaseEntitySectionPanel';
import {useSplitPath} from 'helpers/hooks/links';
import useMediaQuery from '@mui/material/useMediaQuery';

const DatabaseEntityContextWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntityContextWrapper');

  const profileProvider = useProfile();

  const lsDown = useMediaQuery((theme) => theme.breakpoints.down('ls'));

  const [open, setOpen] = useState(!lsDown);
  const [size, setSize] = useState('medium');

  const [, pathPostfix] = useSplitPath('database');
  const pathKey = pathPostfix.split('/')?.[1] ?? 'profile';

  const handleChange = (section) => {
    setSize(section.size ?? 'medium');
  }

  const handleContextToggle = (e, open) => {
    setOpen(open);
  }

  useLayoutEffect(() => {
    setOpen(!lsDown);
  }, [lsDown]);

  return <StyledDatabaseEntityContextWrapper ref={ref} {...innerProps}
                                             variant={lsDown ? 'temporary' : 'standard'}
                                             context={<DatabaseEntitySectionPanel onChange={handleChange}/>}
                                             open={open && Boolean(profileProvider.state?.showContext?.[pathKey])}
                                             onToggle={handleContextToggle}
                                             size={size}>
    {innerProps.children}
  </StyledDatabaseEntityContextWrapper>
});

DatabaseEntityContextWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
};

export default DatabaseEntityContextWrapper;
